module.exports = __webpack_public_path__ + "static/img/icon_naoyingxiang_jingzhun_zhenduan.71396fae.png";